import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { installAuthInterceptor } from "./lib/authInterceptor";
import { initInstallPrompt } from "./lib/installPrompt";

// Fang browserens engangs-event for app-installation så tidligt som muligt.
initInstallPrompt();

// Install global 401 interceptor for Supabase requests — guards against
// queries/mutations that forget to wire up handleSessionError.
installAuthInterceptor(import.meta.env.VITE_SUPABASE_URL);

// PWA: Guard against service worker registration in iframe/preview contexts
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  // Unregister any existing service workers in preview/iframe contexts
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
